import { render, staticRenderFns } from "./QuizBySubjectsGrid.vue?vue&type=template&id=0e748d0f"
import script from "./QuizBySubjectsGrid.vue?vue&type=script&lang=js"
export * from "./QuizBySubjectsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports